import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ReorderError.module.scss';
import cx from 'clsx';
import { useOrderHistory } from 'hooks/context/OrderHistory';
import { Icon } from './Icon';
import { Button, ButtonVariant } from '@clover/web-lib-consumer-ui';

export const ReorderError: FC<{ onClick?: () => void }> = memo(function CartBody({ onClick }) {
  const { t } = useTranslation();
  const { reorderFailureCode } = useOrderHistory();
  const emptyModifiers = reorderFailureCode?.includes('modifier');

  return (
    <>
      <div className={cx(styles.errorWrapper)}>
        <h2 className={cx(styles.errorTitle)}>{t('cart.ohNo')}</h2>
        <p className={cx(styles.errorSubtitle)}>{emptyModifiers ? t('cart.reorderFailedModifiers') : t('cart.reorderFailedItems')}</p>
        <Icon aria-hidden={true} className={cx(styles.errorIcon)} name="sobbing" size={160} />
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          type="button"
          variant= {ButtonVariant.SECONDARY}
          className={styles.button}
          onClick={onClick}
          data-testid={'error-button'}
        >
         <span>{emptyModifiers ? t('cart.backToMenu') : t('cart.orderSomethingElse')}</span>
        </Button>
      </div>
    </>
  );
});
